__turbopack_context__.v({
  "onDark": "W4nTtW_onDark",
  "onLight": "W4nTtW_onLight",
  "outline": "W4nTtW_outline",
});
